/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Not_A_MemberInputs */

const en_us2_group_not_a_member = /** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are not part of this group.`)
};

const pt_br2_group_not_a_member = /** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não faz parte desta turma.`)
};

const pt_pt2_group_not_a_member = /** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não faz parte desta turma.`)
};

/** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */
const es_419_group_not_a_member = en_us2_group_not_a_member;

/** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */
const fr_fr2_group_not_a_member = en_us2_group_not_a_member;

/** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */
const de_de2_group_not_a_member = en_us2_group_not_a_member;

/** @type {(inputs: Group_Not_A_MemberInputs) => LocalizedString} */
const it_it2_group_not_a_member = en_us2_group_not_a_member;

/**
* | output |
* | --- |
* | "You are not part of this group." |
*
* @param {Group_Not_A_MemberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_not_a_member = /** @type {((inputs?: Group_Not_A_MemberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Not_A_MemberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_not_a_member(inputs)
	if (locale === "es-419") return es_419_group_not_a_member(inputs)
	if (locale === "pt-PT") return pt_pt2_group_not_a_member(inputs)
	if (locale === "fr-FR") return fr_fr2_group_not_a_member(inputs)
	if (locale === "de-DE") return de_de2_group_not_a_member(inputs)
	if (locale === "it-IT") return it_it2_group_not_a_member(inputs)
	return en_us2_group_not_a_member(inputs)
});
export { group_not_a_member as "group.not_a_member" }